// AGC: Admin Panel - Metric Card Component
// AGC: Displays a single metric with icon, value, and label

import React from 'react'

interface MetricCardProps {
  icon: string
  value: string | number
  label: string
  color: string
}

/**
 * AGC: MetricCard - Displays a metric in a compact card format
 * AGC: Used in model configuration pages for overview statistics
 */
export const MetricCard: React.FC<MetricCardProps> = ({ icon, value, label, color }) => (
  <div className="bg-white dark:bg-admin-card-dark border border-slate-200 dark:border-white/5 rounded-xl p-5 flex items-center gap-4 shadow-card dark:shadow-none">
    <div 
      className="w-12 h-12 rounded-lg flex items-center justify-center text-2xl"
      style={{ backgroundColor: `${color}20` }}
    >
      {icon}
    </div>
    <div>
      <div className="text-2xl font-bold text-slate-800 dark:text-slate-200">{value}</div>
      <div className="text-sm text-slate-500 dark:text-slate-400">{label}</div>
    </div>
  </div>
)

export default MetricCard


